import React from 'react';
import classNames from 'classnames';
/**
 *
 */
export default function Label(props) {
    var compact = props.compact, model = props.model, htmlFor = props.htmlFor, className = props.className, onRemove = props.onRemove;
    if (!model.color) {
        return null;
    }
    var borderColor = model.getBorderColor();
    var textColor = model.getTextColor();
    var classes = classNames({
        'label': true,
        'label--compact': compact,
        'label--remove': !!onRemove,
        'cursor-pointer': !!onRemove
    }) + ' ' + className;
    return React.createElement("label", { className: classes, title: model.name, style: { backgroundColor: model.color.hex(), color: textColor, borderColor: borderColor.hex() }, onClick: function () { return onRemove ? onRemove(model) : null; }, htmlFor: htmlFor },
        React.createElement("span", null, model.name),
        onRemove && React.createElement("i", { className: "ml-2 label__icon fe fe-x " }));
}
Label.defaultProps = {
    className: ''
};
